import React from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

// import EmojiPicker, { EmojiStyle } from 'emoji-picker-react'

type EmojiIconDialogProps = {
  fullScreen: boolean
  open: boolean
  selectedPlayer?: { id?: number; name?: string }
  onClose: () => void
  onChangeIcon: (playerId: number | undefined, emoji: string) => void
}

const EmojiIconDialog: React.FC<EmojiIconDialogProps> = ({
  fullScreen,
  open,
  selectedPlayer,
  onClose,
  onChangeIcon,
}) => {
  return (
    <Dialog fullScreen={fullScreen} open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle> {selectedPlayer?.name ? `Set ${selectedPlayer.name}'s Icon` : ''}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        Sorry, Icon-selection is currently disabled!
        {/* <EmojiPicker
          searchDisabled={true}
          previewConfig={{
            showPreview: false,
          }}
          emojiStyle={EmojiStyle.APPLE}
          onEmojiClick={(e) => {
            onChangeIcon(selectedPlayer?.id, e.emoji)
            onClose()
          }}
          width="99%"
          height="99%"
        /> */}
      </DialogContent>
      <DialogActions></DialogActions>
    </Dialog>
  )
}

export default EmojiIconDialog
